class testimonialSlider {
  constructor(parent) {
    if(!parent) {
      return;
    }

    this.parent = parent;
    this.init();
  }

  init = () =>{
    const elements = document.querySelectorAll('.testimonial--slider-js');
    elements.forEach((item)=>{
      this.swiper(item)
    })
  }

  swiper = (element) => {
    let loop = element.getAttribute("data-loop") == "true" ? true : false;
    let autoplay = element.getAttribute("data-autoplay") == "true" ? true : false;
    let time = parseInt(element.getAttribute("data-autoplay-time")) * 1000;
    let navigation = element.getAttribute("data-navigation") == "true" ? true : false;
    let slidesPerView = parseInt(element.getAttribute('data-m-slide-per-view'));
    let elId = element.getAttribute("data-id");

    if (window.innerWidth >= 990) {
      slidesPerView = parseInt(element.getAttribute('data-slide-per-view')) + .5;
    }

    if (window.innerWidth >= 750 && window.innerWidth < 990) {
      slidesPerView = 2;
    }

    if (navigation) {
      navigation = {
        nextEl: `.${elId} .swiper-button-next`,
        prevEl: `.${elId} .swiper-button-prev`,
      };
    }
    
    if (autoplay) {
      autoplay = {
        delay: time,
      };
    }

    let swiper = new Swiper(element, {
      // Optional parameters
      loop,
      navigation,
      slidesPerView,
      spaceBetween: 12,
      autoplay,
      breakpoints: {
        768: {
          spaceBetween: 12
        },
        1024: {
          spaceBetween: 24
        }
      },
    });
  };
}
new testimonialSlider(document.querySelector('.section-testimonial'));